import { useEffect, useLayoutEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { NUM_LEVEL } from '../../../constants/layout';
import { getBandsPosition } from '../../Utils/LayoutUtils';
import { selectDisplayModel } from '../../../reducers/layoutReducer/displayModel';
import {
  PANEL_CONFIG_WIDTH_LEVEL_OFFSET,
  PANEL_CONFIG_WIDTH_OFFSET,
} from '../NavigTree/usePanelsConfig';

const MIN_WIDTH_STACK_COL_NAME = 160; // px
const MAX_WIDTH_STACK_COL_NAME = 1600;

const CssVariableUpdater = () => {
  const filters = useSelector((state) => state.objects.filters);

  const { calculatedDisplayMode, fusedDataColumns } =
    useSelector(selectDisplayModel);

  const panelsConfig = useSelector(
    (state) => state.objects.panels,
    shallowEqual
  );

  const getColumnsForLevel = (level) => {
    const objectType = filters[`level${level}`];
    return fusedDataColumns[level];
    // return fusedDataColumns[level].filter((a) =>
    //   objectType?.toLowerCase().startsWith(a.to)
    // );
  };

  const getColumsWitdh = (level) => {
    const columns = getColumnsForLevel(level);
    // Exclure la dernière colonne du `map`
    const widths = columns
      .slice(1, -1)
      .map((item) => ` ${item.w}px `)
      .join(' ');
    // 20 px au debut pour l'icone expand
    // auto pour le name ==> on devra fixer la taille au niveau content
    // Ajouter '1fr' pour la dernière colonne qui occupe l'espace restant
    return ` ${widths} 1fr`;
  };

  const getFirstColumsWitdh = (level) => {
    const columns = getColumnsForLevel(level);
    // alert(JSON.stringify(columns[0].w));
    // Exclure la dernière colonne du `map`
    let width = columns[0]?.w || 200;
    width = Math.min(MAX_WIDTH_STACK_COL_NAME, width);
    return width;
  };

  useEffect(() => {
    if (!panelsConfig) return;

    const canvasWidth = panelsConfig.reduce((s, p) => s + (p?.width || 0), 0);

    // 2) pour chaque niveau: fill = canvasWidth - start(level)
    for (let i = 0; i < NUM_LEVEL; i++) {
      const start = getBandsPosition(i, panelsConfig)?.start ?? 0;
      const fill = Math.max(0, canvasWidth - start);
      document.documentElement.style.setProperty(
        `--stack-width-${i}`,
        `${fill}px`
      );
    }
  }, [panelsConfig]);

  useLayoutEffect(() => {
    if (fusedDataColumns) {
      // ---- PASS 1: mesurer le "first column" le plus petit ----
      let levelInStack = 0;
      let cumulatedOffset = 0;
      let minFirstColObserved = Infinity; // min de (firstCol - offset) sur tous les niveaux
      let firstColWidth = new Array(NUM_LEVEL).fill(0);

      for (let i = 0; i < NUM_LEVEL; i++) {
        const isStack =
          calculatedDisplayMode[i] === 'stack' ||
          calculatedDisplayMode[i] === 'stackcard';

        if (isStack) {
          levelInStack++;
          if (levelInStack > 1) {
            cumulatedOffset +=
              getBandsPosition(i, panelsConfig).start -
              getBandsPosition(i - 1, panelsConfig).start;
          }
        } else {
          levelInStack = 0;
        }

        firstColWidth[i] = getFirstColumsWitdh(i) - cumulatedOffset;

        if (isStack && firstColWidth[i] < minFirstColObserved)
          minFirstColObserved = firstColWidth[i];
        console.log(
          'min first col set by level %d is set to %d',
          i,
          minFirstColObserved
        );
      }

      // diff global à ajouter partout pour garantir le minimum
      let globalDiff = Math.max(
        0,
        MIN_WIDTH_STACK_COL_NAME -
          (isFinite(minFirstColObserved)
            ? minFirstColObserved
            : MIN_WIDTH_STACK_COL_NAME)
      );
      console.log('globalDiff', globalDiff);
      // Update the global CSS variable
      for (let i = 0; i < NUM_LEVEL; i++) {
        const finalFirstColWidth = Math.max(
          MIN_WIDTH_STACK_COL_NAME,
          firstColWidth[i] + globalDiff
        );
        document.documentElement.style.setProperty(
          `--grid-template-${i}`,
          ` auto / auto ${finalFirstColWidth}px ${getColumsWitdh(i)}`
        );
      }
    }
  }, [fusedDataColumns, filters, calculatedDisplayMode, panelsConfig]);

  useEffect(() => {
    if (panelsConfig) {
      // Update the global CSS variable
      let cumulatedPos = PANEL_CONFIG_WIDTH_OFFSET - 75;
      for (let i = 0; i < NUM_LEVEL; i++) {
        document.documentElement.style.setProperty(
          `--tree-panel-width-${i}`,
          `${panelsConfig[i].width + 2}px`
        );

        let offset = 0;
        cumulatedPos += panelsConfig[i].width - offset;

        document.documentElement.style.setProperty(
          `--resizer-${i}-posx`,
          `${cumulatedPos}px`
        );
      }
    }
  }, [panelsConfig]);

  return null; // This component doesn't render anything
};

export default CssVariableUpdater;
